import { useTranslation } from "react-i18next";
import { ShieldCheck, SlidersHorizontal, Truck, BadgeX, Languages } from "lucide-react";
import { SUPPORTED_LANGS } from "@/i18n";
import { FREE_SHIPPING_FROM, eur } from "@/data/catalog";

const ITEMS = [
  { id: "payment", icon: ShieldCheck },
  { id: "setup", icon: SlidersHorizontal },
  { id: "shipping", icon: Truck },
  { id: "nosub", icon: BadgeX },
  { id: "langs", icon: Languages },
];

export const TrustStrip = () => {
  const { t, i18n } = useTranslation();
  const vars = { threshold: eur(FREE_SHIPPING_FROM), n: SUPPORTED_LANGS.length };
  const italian = {
    payment: ["Pagamento sicuro", "Stripe · carte, Apple Pay, Google Pay"],
    setup: ["Configurazione inclusa", "Card pronta all'uso, collegata alla tua pagina Google"],
    shipping: ["Spedizione gratuita da € 50,00", "Consegna in Europa in 3-5 giorni lavorativi"],
    nosub: ["Nessun abbonamento obbligatorio", "Paghi una volta, nessun canone"],
    langs: ["Supporto in 14 lingue", "Sito, e-mail e fatture nella tua lingua"],
  };
  return (
    <section className="bg-[#0b0b0b] border-y border-[#D4AF37]/15" data-testid="trust-strip" aria-label={t("trust.aria")}>
      <ul className="trust-aligned">
        {ITEMS.map(({ id, icon: Icon }) => (
          <li key={id} className="trust-item" data-testid={`trust-${id}`}>
            <span className="w-8 h-8 rounded-full border border-[#D4AF37]/35 bg-[#111] flex items-center justify-center shrink-0"><Icon className="w-4 h-4 text-[#D4AF37]" strokeWidth={1.8} /></span>
            <span className="min-w-0">
              <span className="trust-item-title">{i18n.language?.startsWith("it") ? italian[id][0] : t(`trust.${id}.t`, vars)}</span>
              <span className="trust-item-copy">{i18n.language?.startsWith("it") ? italian[id][1] : t(`trust.${id}.d`, vars)}</span>
            </span>
          </li>
        ))}
      </ul>
    </section>
  );
};
